import React from 'react';
import { Rate as AntdRate } from 'antd';
import cn from 'classnames';

interface StarRatingProps {
  value: number;
  className?: string;
  'data-testid'?: string;
}

/**
 * Read-only star rating (half-star support) mirroring the supplier app's
 * disabled `Rate` usage in order / milestone reviews.
 */
const StarRating: React.FC<StarRatingProps> = ({
  value,
  className,
  'data-testid': dataTestId = 'star-rating',
}) => {
  return (
    <div data-testid={dataTestId}>
      <AntdRate
        value={value}
        disabled
        allowHalf
        className={cn('!text-base !leading-none [&_.ant-rate-star]:!me-1', className)}
      />
    </div>
  );
};

export default StarRating;
